import object from 'helpers/object'


export const initialState = {
  isFetching: true,
  poll: [],
  votesCount: {},
  peopleVotesCount: {},
}

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)

export const setPoll = (state, payload) => (
  object.setIn(state, [ 'poll' ], payload)
)

export const setVotesCount = (state, payload) => (
  object.setIn(state, [ 'votesCount', payload.questionId ], payload.count)
)

export const setPeopleVotesCount = (state, payload) => (
  object.setIn(state, [ 'peopleVotesCount', payload.pollId ], payload.count)
)
